import { MessageCircle } from 'lucide-react';

import { cn } from '@/lib/utils';

const WhatsAppButton = ({
  text = 'Comprar no WhatsApp',
  message = '',
  productName,
  className,
  variant = 'primary',
}) => {
  // Clean phone number to contain only digits
  const cleanPhoneNumber = '5592992533120'; // Hardcoded as requested for the URL

  // Determine the message based on productName mapping or fallback to message prop
  let finalMessage =
    message || 'Olá! Gostaria de saber mais sobre o Lily Book Club.';

  if (productName) {
    if (productName === 'T-shirt') {
      finalMessage =
        "Oi, tenho interesse em comprar a T-shirt Lily's Gang do Lily Book Club";
    } else if (productName === 'Eco Bag') {
      finalMessage =
        'Oi, tenho interesse em comprar a Eco Bag do Lily Book Club';
    } else if (productName === 'Caneca') {
      finalMessage =
        'Oi, tenho interesse em comprar a Caneca do Lily Book Club';
    } else {
      finalMessage = `Oi, tenho interesse em comprar: ${productName}`;
    }
  }

  const encodedMessage = encodeURIComponent(finalMessage);
  const href = `https://wa.me/${cleanPhoneNumber}?text=${encodedMessage}`;

  const variants = {
    primary:
      'bg-wine text-white hover:bg-wine-deep shadow-lg shadow-pink-500/20',
    secondary:
      'bg-[#ADD8E6] text-gray-900 hover:bg-[#ADD8E6]/90 shadow-lg shadow-[#ADD8E6]/20',
    outline: 'border-2 border-wine text-wine hover:bg-blush-light',
    white: 'bg-white text-wine hover:bg-gray-50 shadow-lg',
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-medium transition-all duration-300 active:scale-[0.98]',
        variants[variant],
        className,
      )}
    >
      <MessageCircle className="w-5 h-5" />
      <span>{text}</span>
    </a>
  );
};

export default WhatsAppButton;
